<article class="personal-item" [class.personal-item--disabled]="item.disabled">
  <header class="personal-item__section">
    <div class="checkbox">
      <input
        type="checkbox"
        [(ngModel)]="item.selected"
        (ngModelChange)="onSelect()"
        [id]="item.id"
      />
      <label [for]="item.id">
        <div class="checkbox__el"></div>
      </label>
    </div>

    <h3
      class="personal-item__title"
      [tooltip]="
        item.name
          ? ('BATCH_MAILING.BLANKS_TAB.BLANK_ITEM_TITLE_SHORT' | translate) +
            ' ' +
            item.name
          : ('BATCH_MAILING.BLANKS_TAB.BLANK_ITEM_TITLE' | translate) +
            ' № ' +
            item.id
      "
    >
      {{
        item.name
          ? ('BATCH_MAILING.BLANKS_TAB.BLANK_ITEM_TITLE_SHORT' | translate) +
            ' ' +
            item.name
          : ('BATCH_MAILING.BLANKS_TAB.BLANK_ITEM_TITLE' | translate) +
            ' № ' +
            item.id
      }}
      <p class="personal-item__title-extra">
        {{ 'BATCH_MAILING.BLANKS_TAB.CREATED_AT' | translate }}
        {{
          dayjs(item?.created_at, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY HH:mm')
        }}
      </p>
    </h3>

    <div class="batches-status">
      <span>{{ BLANK_STATUS_MAP.get(item?.status) | translate }}</span>

      @if (item.status === 'processing') {
        <div class="spinner spinner--alt text-center">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      }
    </div>
  </header>
</article>
